module.exports = __webpack_public_path__ + "static/D365-manufacturing-be0e842a9c0f000cab8d64493e63b877.png";